import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19 14.3882L12 21.1053L5 14.3882",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("line", {
      x1: "11.8911",
      y1: "20.7334",
      x2: "11.8911",
      y2: "3.00033",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }